import { IonToggle } from "@ionic/react";
import { forwardRef } from "react";
import { type FieldApi } from "@tanstack/react-form";
import { cn } from "@/lib/style/cva.config";

export type CustomFieldToggleProps = {
  label: string;
  description?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: FieldApi<
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any
  >;
};

export const CustomFieldToggle = forwardRef<
  HTMLIonToggleElement,
  React.ComponentProps<typeof IonToggle> & CustomFieldToggleProps
>(function CustomFieldToggle({ label, description, field, ...props }, ref) {
  return (
    <IonToggle
      ref={ref}
      name={field.name}
      checked={!!field.state.value}
      onIonChange={(event) => field.handleChange(event.detail.checked)}
      onIonBlur={field.handleBlur}
      disabled={field.state.meta.isValidating || field.form.state.isSubmitting}
      {...props}
      labelPlacement={props.labelPlacement ?? "start"}
      justify="space-between"
      children={label}
      className={cn(
        field.state.meta.isTouched && "ion-touched",
        !!field.state.meta.errors && field.state.meta.errors.length > 0 && "ion-invalid",
        props.className,
      )}
    />
  );
});
